// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = ({
  container: {
    zIndex: 2,
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '20px 0'
  },
  line: {
    width: '100%',
    borderWidth: 1,
    borderStyle: 'solid',
    marginTop: 4,
    borderColor: GlobalStyles.color.COLOR_LIGHT_GRAY,
  },
  titleText: {
    width: '100%',
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_BLACK_GREY,
  },
});

export default styles;
